<template>
  <div class="boy_warphry">
    <div class="rkcz">
      <div class="p">16-59岁及以上常住人口受教育程度</div>
      <div class="two">
        <div class="one">
            <span>{{datas.wsgx}}</span><span>人</span>
            <div>未上过学</div>
        </div>
        <div class="one">
            <span>{{datas.xqjy}}</span><span>人</span>
            <div>学前教育</div>
        </div>
        <div class="one">
            <span>{{datas.xx}}</span><span>人</span>
            <div>小学</div>
        </div>
        <div class="one">
            <span>{{datas.cz}}</span><span>人</span>
            <div>初中</div>
        </div>
        <div class="one">
            <span>{{datas.gz}}</span><span>人</span>
            <div>高中</div>
        </div>
        <div class="one">
            <span>{{datas.dxzk}}</span><span>人</span>
            <div>大学专科</div>
        </div>
        <div class="one">
            <span>{{datas.dxbk}}</span><span>人</span>
            <div>大学本科</div>
        </div>
        <div class="one">
            <span>{{datas.ssyjs}}</span><span>人</span>
            <div>硕士研究生</div>
        </div>
        <div class="one">
            <span>{{datas.bsyjs}}</span><span>人</span>
            <div>博士研究生</div>
        </div>
      </div>
    </div>
    <!-- <el-card> -->
    <div class="npm">
      <p>分地区、受教育程度的16-59岁及以上常住人口</p>
      <p>{{dianzi.villages_name}}</p>
      <div ref="echartsINof" class="echarts" style="height: 40vh"></div>
    </div>
    <!-- </el-card> -->
    <!-- 按钮 -->
    <button @click="zuo" class="a"><i class="el-icon-arrow-left"></i></button>
    <button @click="you" class="b"><i class="el-icon-arrow-right"></i></button>
  </div>
</template>

<script>
import { tj } from "@/network";
export default {
  data() {
    return {
      datas:{},
      dianzi:{},
      dian:1
    };
  },
  created() {},
  mounted() {
    this.handEchart();
    this.getInfoData();
  },
  methods: {//jxq_fdqsjycddczrk
    async getInfoData() {
      const { code, data, msg } = await tj({
        tableName: "jxq_fdqsjycddczrk",
        // streetCode: "110105011",
        isOutside:0,
        age:16
      });
      this.datas=data[0]
      this.dianzi=data[this.dian]
      // console.log(data)
      let czrk = [];
      let villages_name = [];
      for (const item of data) {
        czrk.push(item.czrk);
        villages_name.push(item.villages_name);
      }
      this.handEchart(czrk,villages_name)
    },
    zuo(){
      if(this.dian>=2){
      this.dian-=1
      // console.log(this.dian)
      this.getInfoData();}
    },
    you(){
      if(this.dian<=9){
      this.dian+=1
      // console.log(this.dian)
      this.getInfoData();
      }
    },
    handEchart(e,es) {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
         legend: {
          textStyle:{
          color:"#fff",
        },
        },
        textStyle:{
          color:"#fff"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: ["未上过学","学前教育","小学","初中","高中","大学专科","大学本科","硕士研究生","博士研究生"],
            axisLabel: { interval: 0, rotate: 60 }
          },
          
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "男",
            type: "bar",
            stack: "Search Engine",
            barWidth:'50%',
            emphasis: {
              focus: "series",
            },
            data: [this.dianzi.wsgxnan,this.dianzi.xqjynan,this.dianzi.xxnan,this.dianzi.cznan,this.dianzi.gznan,this.dianzi.dxzknan,this.dianzi.dxbknan,this.dianzi.ssyjsnan,this.dianzi.bsyjsnan],
          },
          {
            name: "女",
            type: "bar",
            stack: "Ad",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: [this.dianzi.wsgxnv,this.dianzi.xqjynv,this.dianzi.xxnv,this.dianzi.cznv,this.dianzi.gznv,this.dianzi.dxzknv,this.dianzi.dxbknv,this.dianzi.ssyjsnv,this.dianzi.bsyjsnv],
          },
          // {
          //   name: "总计",
          //   type: "bar",
          //   stack: "Ad",
          //   stack: "Search Engine",
          //   emphasis: {
          //     focus: "series",
          //   },
          //   data: [this.dianzi.wsgx,this.dianzi.xqjy,this.dianzi.xx,this.dianzi.cz,this.dianzi.gz,this.dianzi.dxzk,this.dianzi.dxbk,this.dianzi.ssyjs,this.dianzi.bsyjs],
          // },
        ],
      };
      myechart.setOption(option);
    },
  },
};
</script>

<style  scoped lang="less">
button{
  border: 1px solid #21517d;
  width: 2vw;
  height: 4vh;
  background-color: rgba(20, 58, 126, 0.5);
  position: absolute;
  top: 33vh;
  left: 3vw;
  color: #fff;
}
.b{
  left: 27vw;
}
.boy_warphry {
  background-color: rgba(20, 48, 99, 0);
  .npm {
    p {
      color: #fff;
      text-align: center;
      font-size: 18px;
      padding: 2vh;
    }
    .echarts{
        margin: 1vw;
    }
  }
}
.rkcz {
  .p {
    color: #fff;
    text-align: center;
    margin-top: 2vh;
    font-size: 18px;
    margin-bottom: 2vh;
  }
  .two {
    text-align: center;
    border: 1px solid #21517d;
    margin: 0 2vw;
    margin-bottom: 1vw;
    padding: 1vw 0;
    .one {
      width: 5vw;
      display: inline-block;
      font-size: 18px;
      color: #fffd7d;
      padding-top: 1vh;
      span:nth-child(2) {
        font-size: 12px;
      }
      div {
        font-size: 12px;
        color: #fff;
        margin-top: 5px;
      }
    }
  }
  
}
</style>
